import { render, staticRenderFns } from "./CbsObjectTable.vue?vue&type=template&id=0463ff22&scoped=true"
import script from "./CbsObjectTable.vue?vue&type=script&lang=js"
export * from "./CbsObjectTable.vue?vue&type=script&lang=js"
import style0 from "./CbsObjectTable.vue?vue&type=style&index=0&id=0463ff22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0463ff22",
  null
  
)

export default component.exports